import { render, staticRenderFns } from "./ModalDeletePlan.vue?vue&type=template&id=47b2b6ac"
import script from "./ModalDeletePlan.vue?vue&type=script&lang=js"
export * from "./ModalDeletePlan.vue?vue&type=script&lang=js"
import style0 from "./ModalDeletePlan.vue?vue&type=style&index=0&id=47b2b6ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports